(function () {
    'use strict';

    var module = angular.module("imApp");

    module.factory("mapViewService", ['p2DataTaskService', function (p2DataTaskService) {
        var service = {
            loadMapViewGet: function (argtype, argvalue) {
                return p2DataTaskService.call(1282, {
                    argtype: argtype,
                    argvalue: argvalue
                });
            },
            loadGisObjectsGet: function (argtype, argvalue) {
                return p2DataTaskService.call(1283, {
                    argtype: argtype,
                    argvalue: argvalue
                });
            }
        };

        return service;
    }]);
})();